import React from 'react';
import { Link } from 'react-router-dom';

const PortfolioPage = () => {
  const portfolioItems = [
    {
      category: "Residential Landscaping",
      description: "Complete backyard transformation featuring custom patios, retaining walls, and comprehensive plant selection.",
      features: ["Custom Patio Design", "Stone Retaining Walls", "Professional Plant Installation", "Irrigation Systems", "Outdoor Lighting"],
      image: (
        <svg className="service-icon" fill="var(--primary-500)" viewBox="0 0 24 24" style={{ width: '64px', height: '64px' }}>
          <path d="M12,2L3.09,8.26L4.11,21.53L12,17.27L19.89,21.53L20.91,8.26L12,2M12,4.87L17.5,8.6L16.5,19.4L12,16.15L7.5,19.4L6.5,8.6L12,4.87Z"/>
        </svg>
      )
    },
    {
      category: "Commercial Projects", 
      description: "Professional landscape design and installation for commercial properties and business complexes.",
      features: ["Site Planning", "Irrigation Systems", "Seasonal Maintenance", "Traffic Flow Design", "Sustainable Solutions"],
      image: (
        <svg className="service-icon" fill="var(--primary-500)" viewBox="0 0 24 24" style={{ width: '64px', height: '64px' }}>
          <path d="M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8M10,9A4,4 0 0,1 14,5A4,4 0 0,1 18,9A4,4 0 0,1 14,13A4,4 0 0,1 10,9Z"/>
        </svg>
      )
    },
    {
      category: "Hardscaping Excellence",
      description: "Beautiful outdoor living spaces featuring premium materials and expert craftsmanship.",
      features: ["Natural Stone Patios", "Walkways & Steps", "Outdoor Kitchens", "Fire Pits", "Pergolas & Arbors"],
      image: (
        <svg className="service-icon" fill="var(--primary-500)" viewBox="0 0 24 24" style={{ width: '64px', height: '64px' }}>
          <path d="M19.5,19.5L21,21L19.5,22.5L18,21L19.5,19.5M17,8.5L8.5,17L6.5,15L15,6.5L17,8.5M19,3L21,5L17,9L15,7L19,3M3,17.5L4.5,19L8,15.5L6.5,14L3,17.5Z"/>
        </svg>
      )
    },
    {
      category: "Garden Center Showcase",
      description: "Central Virginia's premier source for trees, shrubs, annuals, perennials, and seasonal plants.",
      features: ["Native Plants", "Seasonal Selections", "Expert Plant Care Advice", "Container Gardens", "Bulk Materials"],
      image: (
        <svg className="service-icon" fill="var(--primary-500)" viewBox="0 0 24 24" style={{ width: '64px', height: '64px' }}>
          <path d="M12,2L13.09,8.26L19,9L14.18,13L19.09,19L12,16.9L4.91,19L9.82,13L5,9L10.91,8.26L12,2Z"/>
        </svg>
      )
    },
    {
      category: "Design & Planning",
      description: "Professional design services including 3D visualization and comprehensive master planning.",
      features: ["3D Design Renderings", "Master Planning", "Site Analysis", "Plant Selection", "Construction Documents"],
      image: (
        <svg className="service-icon" fill="var(--primary-500)" viewBox="0 0 24 24" style={{ width: '64px', height: '64px' }}>
          <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"/>
        </svg>
      )
    },
    {
      category: "Maintenance Services",
      description: "Ongoing care and maintenance to keep your landscape looking its best year-round.",
      features: ["Seasonal Cleanup", "Lawn Care", "Tree & Shrub Care", "Mulching", "Plant Health Monitoring"],
      image: (
        <svg className="service-icon" fill="var(--primary-500)" viewBox="0 0 24 24" style={{ width: '64px', height: '64px' }}>
          <path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22C6.47,22 2,17.5 2,12A10,10 0 0,0 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z"/>
        </svg>
      )
    }
  ];

  const testimonials = [
    {
      quote: "Snow's transformed our backyard into an oasis. The patio and landscape design exceeded our expectations.",
      author: "Sarah M., Charlottesville"
    },
    {
      quote: "Professional service from start to finish. They delivered exactly what they promised, on time and within budget.",
      author: "Michael R., Albemarle County"
    },
    {
      quote: "We've been working with Snow's for over 15 years. Their expertise and reliability are unmatched in Central Virginia.",
      author: "Jennifer L., Fluvanna County"
    }
  ];

  return (
    <div className="PortfolioPage">
      {/* Hero Section for Portfolio */}
      <section className="section" style={{ 
        background: 'linear-gradient(135deg, var(--primary-100), var(--background-surface))',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ color: 'var(--primary-700)' }}>Our Portfolio</h1>
          <p style={{ fontSize: 'var(--text-lg)', maxWidth: '800px', margin: '0 auto' }}>
            Explore our completed projects and see why Central Virginia homeowners and businesses 
            trust Snow's Garden Center for their landscaping needs.
          </p>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="section">
        <div className="container">
          <div className="grid grid-cols-2">
            {portfolioItems.map((item, index) => (
              <div key={index} className="card">
                <div style={{ 
                  height: '200px', 
                  background: `linear-gradient(135deg, var(--primary-100), var(--background-page))`,
                  borderRadius: 'var(--border-radius-sm)',
                  marginBottom: 'var(--space-md)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {item.image}
                </div>
                <h3 style={{ color: 'var(--primary-700)', marginBottom: 'var(--space-sm)' }}>
                  {item.category}
                </h3>
                <p style={{ color: 'var(--neutral-400)', marginBottom: 'var(--space-md)' }}>
                  {item.description}
                </p>
                <ul style={{ 
                  listStyle: 'none', 
                  padding: 0,
                  marginBottom: 'var(--space-md)'
                }}>
                  {item.features.map((feature, featureIndex) => (
                    <li key={featureIndex} style={{ 
                      display: 'flex', 
                      alignItems: 'center',
                      marginBottom: 'var(--space-xs)',
                      color: 'var(--neutral-900)'
                    }}>
                      <svg style={{ 
                        width: '16px', 
                        height: '16px', 
                        color: 'var(--success)',
                        marginRight: 'var(--space-xs)'
                      }} fill="currentColor" viewBox="0 0 24 24">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                      </svg>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Testimonials */}
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxxl)' }}>
            <h2>What Our Customers Say</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', maxWidth: '600px', margin: '0 auto' }}>
              Don't just take our word for it. Here's what our satisfied customers have to say about our work.
            </p>
          </div>
          
          <div className="grid grid-cols-3">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="card" style={{ textAlign: 'center' }}>
                <blockquote style={{ 
                  fontSize: 'var(--text-md)', 
                  fontStyle: 'italic',
                  color: 'var(--neutral-900)',
                  marginBottom: 'var(--space-md)',
                  lineHeight: '1.6'
                }}>
                  "{testimonial.quote}"
                </blockquote>
                <cite style={{ 
                  fontWeight: '600', 
                  color: 'var(--primary-700)',
                  fontSize: 'var(--text-sm)'
                }}>
                  — {testimonial.author}
                </cite>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Project Process */}
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 'var(--space-xxxl)' }}>
            <h2>Our Process</h2>
            <p style={{ fontSize: 'var(--text-lg)', color: 'var(--neutral-400)', maxWidth: '600px', margin: '0 auto' }}>
              From initial consultation to project completion, we ensure a smooth and professional experience.
            </p>
          </div>
          
          <div className="grid grid-cols-4">
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
                </svg>
              </div>
              <h3 className="service-title">1. Consultation</h3>
              <p className="service-description">Free consultation to understand your vision and site requirements.</p>
            </div>
            
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
                </svg>
              </div>
              <h3 className="service-title">2. Design</h3>
              <p className="service-description">Professional design with 3D visualization and detailed planning.</p>
            </div>
            
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z"/>
                </svg>
              </div>
              <h3 className="service-title">3. Installation</h3>
              <p className="service-description">Expert installation using premium materials and proven techniques.</p>
            </div>
            
            <div className="card service-card">
              <div className="service-icon">
                <svg fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"/>
                </svg>
              </div>
              <h3 className="service-title">4. Completion</h3>
              <p className="service-description">Final walkthrough and ongoing support for your new landscape.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section" style={{ backgroundColor: 'var(--background-surface)' }}>
        <div className="container">
          <div className="card" style={{ 
            marginTop: 'var(--space-xxxl)',
            textAlign: 'center',
            background: 'var(--primary-100)',
            border: '2px solid var(--primary-500)'
          }}>
            <h2 style={{ color: 'var(--primary-700)' }}>Ready to Start Your Project?</h2>
            <p style={{ marginBottom: 'var(--space-lg)' }}>
              Let's discuss how we can bring your outdoor vision to life. Contact us today for a free consultation.
            </p>
            <div style={{ display: 'flex', gap: 'var(--space-md)', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn btn-primary">
                Schedule Consultation
              </Link>
              <Link to="/services" className="btn btn-secondary">
                View Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PortfolioPage;